import { useEffect } from 'react';
import { trackEvent } from '../services/analytics';

/**
 * Fires a descriptive page-view event once on mount.
 *
 * Pass the role-specific event constant (e.g. EVENTS.trainer.DASHBOARD_VIEWED)
 * — super properties set at login time (role, user_id, school_id,
 * alforaa_id) are attached automatically by Mixpanel, so you only need
 * to pass page-specific context in `extraProps`.
 *
 * @example
 * usePageView(EVENTS.trainer.DASHBOARD_VIEWED);
 * usePageView(EVENTS.student.CURRICULUM_DETAIL_VIEWED, { curriculum_id });
 */
export function usePageView(
	eventName: string,
	extraProps: Record<string, unknown> = {},
): void {
	useEffect(() => {
		trackEvent(eventName, extraProps);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}
